import { gql } from '@apollo/client'

export const CreatorFragment = gql`
  fragment CreatorFragment on Creator {
    id
    createdAt
    updatedAt
    firstName
    lastName
    email
    status
    onboarding
    gender
    ethnicity
    petsOwner
    occupation
    birthday
    childAgeRanges
    interests
    addressLine1
    addressLine2
    addressCity
    addressCounty
    addressState
    addressPostcode
    countryCode
    paypalEmail
    bio
    qualityScore
    pausedReason
    pausedDescription
    metadata {
      ratingsScore
      ratingsCount
    }
    unreadMessagesCount
    isPremium
    phoneNumber
    sourceChannel

    instagramHandle
    tiktokHandle
    canvaLink
    otherSocialMediaLink

    resubmissionCount
    age
    ageGroup
    portfolioItemsCount
    canApplyToCampaigns
    minPortfolioItems
    maxResubmissions

    introVideo {
      url
      name
    }

    avatar {
      url
      name
    }

    thumbnail {
      url
      name
    }
  }
`

export const CreatorMetadataFragment = gql`
  fragment CreatorMetadataFragment on CreatorMetadata {
    id
    ratingsScore
    ratingsCount
    approvedAt
    rejectedAt
    warningsCount
  }
`

export const CreatorForBrandFragment = gql`
  fragment CreatorForBrandFragment on Creator {
    id
    createdAt
    updatedAt
    firstName
    lastName
    gender
    ethnicity
    petsOwner
    occupation
    birthday
    childAgeRanges
    interests
    addressLine1
    addressLine2
    addressCity
    addressCounty
    addressState
    addressPostcode
    countryCode
    bio
    metadata {
      ratingsScore
      ratingsCount
    }
    isPremium
    sourceChannel
    age
    ageGroup

    introVideo {
      url
      name
    }

    avatar {
      url
      name
    }

    thumbnail {
      url
      name
    }
  }
`
